// extracted by mini-css-extract-plugin
module.exports = {"promoTop":"promo-top_promoTop__TCFKC","title":"promo-top_title__Ec0j6","sideButton":"promo-top_sideButton__NDjp9"};